import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as sidebarApi from '../Api/sidebarApi';

const SIDEBAR_KEY = 'sidebar';

export const useMenuItems = () =>
	useQuery({
		queryKey: [SIDEBAR_KEY],
		queryFn: () => sidebarApi.getAllMenuItems(),
		staleTime: 1000 * 60 * 10, // 10 minutes
		cacheTime: 1000 * 60 * 30, // 30 minutes
		refetchOnWindowFocus: false,
		initialData: () => {
			const cached = localStorage.getItem('menuItems');
			return cached ? JSON.parse(cached) : undefined;
		},
		onSuccess: (data) => {
			localStorage.setItem('menuItems', JSON.stringify(data));
		},
	});

export const useCreateMenuItem = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: sidebarApi.createMenuItem,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [SIDEBAR_KEY] });
		},
	});
};

export const useUpdateMenuItem = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id, updatedData }) =>
			sidebarApi.updateMenuItem(id, updatedData),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [SIDEBAR_KEY] });
		},
	});
};

export const useDeleteMenuItem = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (id) => sidebarApi.deleteMenuItem(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [SIDEBAR_KEY] });
		},
	});
};
